import { AfterContentChecked, Component, ContentChild, ElementRef, TemplateRef, } from '@angular/core';

@Component({
    selector: 'lib-lazy-load',
    templateUrl: './lazy-load.component.html',
    styleUrls: ['./lazy-load.component.scss'],
})
export class LazyLoadComponent implements AfterContentChecked {
    constructor(private elRef: ElementRef) {}

    @ContentChild('body', { static: false }) contentTemplate!: TemplateRef<ElementRef>;
    loadContent!: boolean;

    ngAfterContentChecked() {

        if (this.elRef.nativeElement.offsetParent) {
            this.loadContent = true;
        }
    }
}
